import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { CommonProps } from "@utils/interface";
import {
  DashcamContainer,
  Heading,
  ImageWrapper,
  View360Container
} from "./styles";
import View360Icon from "@public/images/dashcam/360view.svg";

export interface IDashcamModel extends CommonProps {
  heading?: string;
  model_src?: string;
}

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const DashcamModel = (props: IDashcamModel) => {
  const { heading, model_src, is_visible } = props;
  
  useEffect(() => {
    if (!document.querySelector('script[src*="model-viewer"]')) {
      const script = document.createElement("script");
      script.type = "module";
      script.src =
        "https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js";
      document.head.appendChild(script);
    }
  }, []);  

  return is_visible ? (
    <DashcamContainer>
      <Heading>{heading}</Heading>
      <ImageWrapper>
          <model-viewer 
            src={model_src} 
            alt="Dashcam 3D Model" 
            auto-rotate 
            camera-controls 
            style={{ 
              width: '100%', 
              height: '300px',
              maxWidth: '500px'
            }}
          />
        <View360Container>
          <View360Icon width={48} height={24} />
        </View360Container>
      </ImageWrapper>
    </DashcamContainer>
  ) : (
    <></>
  );
};

export default connect(mapStateToProps)(DashcamModel);
